module.exports = __webpack_public_path__ + "media/images/top/feature_img_01_pc-ded49d5cc9a734c3acad321d333ee119.png";